import React, { useState, useEffect, useRef } from 'react';
import './index.less';
import { ExclamationCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Form, message, Modal, Spin, Button, DatePicker } from 'antd';
import apis from '../../../apis';
import { getQuery } from '@/common/utils';
import AddResourceItem from './components/add-resource-item/';
import EditResourceItem from './components/edit-resource-item/';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import IconTip from '@/components/icon-tip';

const { RangePicker } = DatePicker;

const Publish = (props) => {
  const resourceStateCode = getQuery('resourceStateCode');
  const [form] = Form.useForm();
  const [num, setNum] = useState(0);
  const [resourceInfo, setResourceInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resourceId, setResourceId] = useState('');
  const [resourceEditInfo, setResourceEditInfo] = useState([]);
  const [resourceOpenUsers, setResourceOpenUsers] = useState([
    {
      flag: '0',
    },
  ]);

  const getEditResourceInfoRef = useRef(null);
  getEditResourceInfoRef.current = getEditResourceInfo;

  useEffect(() => {
    setLoading(true);
    apis
      .resourceStateGetByResourceStateCode({ resourceStateCode })
      .then((res) => {
        if (res && res.data && res.ret === '0') {
          setResourceInfo(res.data.resourceState);
          if (res.data.resourceId) {
            // 请求编辑资源接口
            setResourceId(res.data.resourceId);
            getEditResourceInfoRef.current();
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        message.error(err);
        setLoading(false);
      });
  }, [resourceStateCode]);

  function getEditResourceInfo() {
    apis
      .cmsResourceListCmsResource({ resourceStateCode })
      .then((res) => {
        if (res && res.ret === '0' && res.data) {
          setResourceEditInfo(res.data.resources);
          const { resourceOpenUsers } = res.data.resources[0];
          let num = 0;
          resourceOpenUsers.forEach((item) => {
            item.flag = String(num);
            num = num + 1;
          });
          setNum(num);
          setResourceOpenUsers(resourceOpenUsers);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        message.error(err);
        setLoading(false);
      });
  }

  function addStar(name) {
    return (
      <span>
        <span className="star">*</span>
        {name}
      </span>
    );
  }

  function addLine() {
    const obj = Object.assign([], resourceOpenUsers);
    obj.unshift({
      flag: String(num + 1),
    });
    setResourceOpenUsers(obj);
    setNum(num + 1);
  }

  function minusLine(flag) {
    setResourceOpenUsers(resourceOpenUsers.filter((item) => item.flag !== flag));
  }

  function onFinish() {
    const params = {};

    form
      .validateFields()
      .then((value) => {
        params.attractInvestmentStartTime = value.time[0].valueOf();
        params.attractInvestmentEndTime = value.time[1].valueOf();
        params.resourceStateCode = resourceInfo.resourceStateCode;
        params.resourceName = resourceInfo.resourceName;
        params.resourceOpenUsers = [];
        for (const key in value.erp) {
          if (key) {
            params.resourceOpenUsers.push({
              erp: value.erp[key],
              resourceNum: value.resourceNum[key],
              accountId: value.accountId[key],
            });
          }
        }
        Modal.confirm({
          title: '提示',
          icon: <ExclamationCircleOutlined />,
          content: '确认发布当前资源吗？',
          okText: '确认',
          cancelText: '取消',
          onOk() {
            publishResource(params);
          },
        });
      })
      .catch((err) => {});
  }

  function publishResource(params) {
    if (resourceId) {
      params.resourceId = resourceId;
      apis
        .cmsResourceUpdateResource(params)
        .then((res) => {
          if (res && res.ret === '0') {
            message.success('发布成功！');
            props.history.push('/material-manage/resource-list/list');
          } else {
            message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          message.error('发布失败！', err);
        });
    } else {
      apis
        .cmsResourceAddResource(params)
        .then((res) => {
          if (res && res.ret === '0') {
            message.success('发布成功！');
            props.history.push('/material-manage/resource-list/list');
          } else {
            message.error('发布失败！');
          }
        })
        .catch((err) => {
          console.log(err);
          message.error('发布失败！', err);
        });
    }
  }

  function disabledDate(current) {
    // Can not select days before today
    return current && current < moment().endOf('day').subtract(1, 'day');
  }

  const formLayout = {
    labelCol: { span: 2 },
  };

  return (
    <div className="manage-publish-wrap">
      <div className="manage-publish-title">
        <div className="title">{resourceInfo.resourceName}--资源发布</div>
        <div className="name">
          <span>资源位：{resourceInfo.resourceName}</span>
          <span style={{ marginLeft: '35px' }}>资源位ID：{resourceStateCode}</span>
        </div>
      </div>
      {!loading ? (
        <div className="main-content">
          <Form form={form} onFinish={onFinish} labelAlign="right" {...formLayout}>
            <Form.Item label={addStar('可申请时间段')}>
              <Form.Item
                name="time"
                noStyle
                rules={[{ required: true, message: '不能为空！' }]}
                initialValue={
                  resourceEditInfo[0] && [
                    moment(resourceEditInfo[0].attractInvestmentStartTime),
                    moment(resourceEditInfo[0].attractInvestmentEndTime),
                  ]
                }
              >
                <RangePicker
                  showTime
                  className="form-el-full-size"
                  placeholder={['开始日期', '结束日期']}
                  style={{ width: '500px' }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
              <span className="time-text">被分配人只能在申请时间内进行资源申请，申请时间设定后可进行修改。</span>
            </Form.Item>
            <Form.Item label={addStar('分配资源')}>
              <div className="resource-text">
                <div style={{ width: '175px' }}>ERP</div>
                <div style={{ width: '175px' }}>资源数</div>
                <div style={{ width: '175px' }}>
                  已申请资源数
                  <IconTip title="当前被分配的erp用户的申请进度" type="question" />
                </div>
                <PlusCircleOutlined className="add-line-icon" onClick={addLine} />
              </div>
              <Form.Item>
                {resourceOpenUsers.length > 0 &&
                  resourceOpenUsers.map((item, index) => (
                    <React.Fragment key={index}>
                      {resourceEditInfo.length > 0 ? (
                        <EditResourceItem minusLine={minusLine} resourceOpenUsers={resourceOpenUsers} item={item} />
                      ) : (
                        <AddResourceItem minusLine={minusLine} resourceOpenUsers={resourceOpenUsers} item={item} />
                      )}
                    </React.Fragment>
                  ))}
              </Form.Item>
            </Form.Item>
            <div className="btn-wrap">
              <Link to="/material-manage/resource-list/list">
                <Form.Item>
                  <Button style={{ marginRight: '20px' }}>取消</Button>
                </Form.Item>
              </Link>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  确认
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      ) : (
        <div className="spin-loading">
          <Spin />
        </div>
      )}
    </div>
  );
};

export default withRouter(Publish);
